import React from 'react';
import { insidePages } from '../data/content';
interface PageFrameProps {
  src: string;
  caption: string;
  width: number;
  height: number;
  isFeatured?: boolean;
}
function PageFrame({
  src,
  caption,
  width,
  height,
  isFeatured = false
}: PageFrameProps) {
  return <figure className="w-full" data-id="element-16" data-mp="297wtav6chrfz">
      <div className={`overflow-hidden rounded-[14px] border border-brand-charcoal/10 bg-white ${isFeatured ? 'shadow-[0_26px_60px_-30px_rgba(120,84,64,0.35)]' : 'shadow-[0_18px_44px_-28px_rgba(120,84,64,0.3)]'}`} data-id="element-17" data-mp="298okltswt30g">
        <img src={src} alt={`${caption} — a real page from The Baby Sleep Bible`} width={width} height={height} loading="lazy" decoding="async" sizes="(min-width: 768px) 34vw, 82vw" className="block h-auto w-full object-contain" data-id="element-18" data-mp="31xvkox80i0nt" />
      </div>
      <figcaption className="mt-3 text-center font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/45" data-id="element-19" data-mp="2s4y795hvn1w2">
        {caption}
      </figcaption>
    </figure>;
}
export function InsidePages() {
  const [left, center, right] = insidePages;
  return <div className="relative" data-id="element-20" data-mp="1mnnmdeb0s48g">
      {/* warm panel behind the composition, for depth */}
      <div aria-hidden="true" className="absolute inset-x-6 bottom-8 top-16 hidden rounded-[20px] bg-brand-oatmeal/60 md:block" data-id="element-21" data-mp="1rke3m4yk95vg" />

      {/* Mobile — one page at a time, swipeable */}
      <div className="no-scrollbar -mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-2 md:hidden" role="group" aria-label="Pages from The Baby Sleep Bible — swipe to browse" data-id="element-22" data-mp="1huukcy6xra02">
        {insidePages.map(page => <div key={page.src} className="w-[82%] flex-none snap-center" data-id="element-23" data-mp="18vzanc4onhs0">
            <PageFrame {...page} data-id="element-24" data-mp="uvokkbb7677w" />
          </div>)}
      </div>
      <p className="mt-3 text-center font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/40 md:hidden" data-id="element-25" data-mp="ux9hu8owc49g">
        Swipe to see more pages
      </p>

      {/* Desktop — editorial three-page composition */}
      <div className="relative hidden items-center justify-center px-6 py-10 md:flex" data-id="element-26" data-mp="2tasvr8pl684g">
        <div className="w-[30%] max-w-[300px] translate-y-6" data-id="element-27" data-mp="2t8gih8urwlxq">
          <PageFrame {...left} data-id="element-28" data-mp="63ww9owu1m87" />
        </div>
        <div className="relative z-10 -mx-[2.5%] w-[38%] max-w-[400px]" data-id="element-29" data-mp="138vwcmprt1b">
          <PageFrame {...center} isFeatured data-id="element-30" data-mp="15d7zhurnyco" />
        </div>
        <div className="w-[30%] max-w-[300px] translate-y-6" data-id="element-31" data-mp="3t8306cc6r885">
          <PageFrame {...right} data-id="element-32" data-mp="3o7yjal7d8bhe" />
        </div>
      </div>
    </div>;
}